import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    change_form_id: 0
  },
  mutations: {
    setChangeForm(state, id) {
      state.change_form_id = id;
    }
  },
  actions: {}
});
